export default __webpack_public_path__ + "static/media/member_icon.8f6ff74d.svg";